import * as React from 'react';

import './BurgerIcon.scss';

export const BurgerIcon = () => {
    return (
        <div className="icon-burger__container">
            <span><i className="icon icon-btn-burger"></i></span>
        </div>
    );
}
